import type { Shape } from '~/types/grid.types'
import { SHAPE_IDS } from './shapesIdsSquare'

export const PEAK_SQUARE_SHAPES: Shape[] = [
  {
    type: 'rect',
    id: SHAPE_IDS.PEAK_SMALL,
    icon: 'SmallPeak',
    prefix: 'SmallPeak',
    label: 'Small Peak',
    w: 60,
    h: 120,
    menuAlign: 'right',
    children: [
      {
        type: 'rect',
        id: 'SmallPeak90',
        icon: 'SmallPeak',
        prefix: 'SmallPeak',
        label: 'Small Peak 90°',
        w: 60,
        h: 120,
        rotation: 90,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.PEAK_LARGE,
    icon: 'LargeCenterPeak',
    prefix: 'LargeCenterPeak',
    label: 'Large Center Peak',
    w: 60,
    h: 240,
    menuAlign: 'right',
    children: [
      {
        type: 'rect',
        id: 'LargeCenterPeak90',
        icon: 'LargeCenterPeak',
        prefix: 'LargeCenterPeak',
        label: 'Large Center Peak 90°',
        w: 60,
        h: 240,
        rotation: 90,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.PEAK_LARGE_OFFSET,
    icon: 'LargeUpperPeak',
    prefix: 'LargeUpperPeak',
    label: 'Large Upper Peak',
    w: 60,
    h: 240,
    menuAlign: 'right',
    children: [
      {
        type: 'rect',
        id: 'LargeUpperPeak90',
        icon: 'LargeUpperPeak',
        prefix: 'LargeUpperPeak',
        label: 'Large Upper Peak 90°',
        w: 60,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: 'LargeUpperPeak180',
        icon: 'LargeUpperPeak',
        prefix: 'LargeUpperPeak',
        label: 'Large Upper Peak 180°',
        w: 60,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: 'LargeUpperPeak270',
        icon: 'LargeUpperPeak',
        prefix: 'LargeUpperPeak',
        label: 'Large Upper Peak 270°',
        w: 60,
        h: 240,
        rotation: 270,
      },
    ],
  },
]
